<template>
  <div class="promo-single">
    <div :style="{ backgroundColor: this.data.imgBgrColor }" class="promo-single_poster">
      <div class="container">
        <img :src="getPoster" alt="" class="promo-single_poster_image">
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 promo-single_coupon_before promo-single-text">
          <div v-html="this.data.textOne" />
        </div>
      </div>
    </div>
    <CouponAlternate v-if="showPromoCode" :code="this.data.promoCode.code" class="promo-single_coupon" />
    <div class="container">
      <div class="row">
        <div class="col-12 promo-single_coupon_after promo-single-text">
          <div v-html="this.data.textTwo" />
        </div>
      </div>
    </div>
    <!-- <Product class="promo-single_product" :isInlineCard="true" :item="getCurrentProduct" /> -->
    <div class="container">
      <div class="row">
        <div class="col-12 promo-single_offers_title">
          <InnerTitle>
            <template v-slot:title>
              Акции
            </template>
          </InnerTitle>
        </div>
        <div class="col-12 promo-single_offers_slider">
          <PromoSlider
            :items="items"
            :currentId="currentItemId"
          />
        </div>
      </div>
      <div class="row">
        <Banner class="promo-single_banner" />
      </div>
    </div>
  </div>
</template>

<script>
import PlainText from '@/components/UI/PlainText'
import CouponAlternate from '@/components/UI/CouponAlternate'
import Product from '@/components/page/Product/Product'
import InnerTitle from '@/components/UI/InnerTitle'
import PromoSlider from '@/components/page/PromoSlider'
import Banner from '@/components/page/Banner'

export default {
  components: { PlainText, CouponAlternate, Product, InnerTitle, PromoSlider, Banner },
  data () {
    return {
      poster: '/uploads/poster.png',
      textOne: '',
      textTwo: '',
      imgBgrColor: '#fff',
      promoCode: null,
    }
  },
  computed: {
    getMetaTitle () {
      if (this.data) {
        return this.data.metaTitle ? this.data.metaTitle : `${this.data.name} | СУШИСЕТ`
      }
      return ''
    },
    getMetaDescription () {
      if (this.data) {
        return this.data.metaDescription
          ? this.data.metaDescription
          : `${this.data.name} и другие скидки на суши, роллы и пиццу в Санкт-Петербурге от службы доставки СУШИСЕТ.`
      }
      return ''
    },
    currentItemId () { return this.data.id || 0 },
    getPoster () { return this.data ? this.data.image : '' },
    showPromoCode () {
      if (this.data.promoCode) {
        if (this.data.promoCode.action !== 'friendPercent' &&
						this.data.promoCode.action !== 'birthDay') {
          return true
        }
      }
      return false
    },
  },
  async asyncData ({ $axios, store, route, error }) {
    try {
      const api = store.getters['api/getPromotions']
      const res = await $axios.get(api)
      const items = res.data.items

      const apiSingle = store.getters['api/getPromotionsSingle'](route.params.id)
      const resSingle = await $axios.get(apiSingle)
      const itemsSingle = resSingle.data.data

      return {
        data: itemsSingle,
        items,
      }
    } catch (e) {
      error({ statusCode: 404, message: 'region not found' })
    }
  },
  head () {
    return {
      title: this.getMetaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.getMetaDescription,
        },
      ],
    }
  },
}
</script>

<style lang="less">
.promo-single {
	&_poster {
		width: 100%;
		margin-bottom: 30px;

		@media screen and (max-width: 992px) { background-color: transparent; }

		@media screen and (max-width: 576px) {
			width: calc(100% - 30px);
			margin: 0 15px;
		}

		&_image {
			max-width: 100%;
			height: auto;
			max-height: 400px;
			display: block;
			margin: 0 auto;
		}
	}

	&-text {
		line-height: 1.3;

		p {
			margin:0 0 15px 0;
		}
	}

	&_coupon {
		margin-bottom: 45px;

		&_before {
			margin-bottom: 34px;
		}

		&_after {
			margin-bottom: 21px;
		}
	}

	&_product {
		margin-bottom: 30px;
	}

	&_offers {
		&_title {
			margin-bottom: 30px;
		}

		&_slider {
			margin-bottom: 95px;
		}
	}

	&_banner {
		margin-bottom: 55px;
	}
}
</style>
